import { render, staticRenderFns } from "./LabourerCard.vue?vue&type=template&id=88f2e43e&scoped=true&"
import script from "./LabourerCard.vue?vue&type=script&lang=js&"
export * from "./LabourerCard.vue?vue&type=script&lang=js&"
import style0 from "./LabourerCard.vue?vue&type=style&index=0&id=88f2e43e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f2e43e",
  null
  
)

export default component.exports